import { useEffect } from 'react';

export const useBoardCommandTick = ({ tick, lastHandledTickRef, onConsume }) => {
  useEffect(() => {
    if (!Number.isFinite(tick) || tick < 1) {
      return;
    }
    if (lastHandledTickRef?.current === tick) {
      return;
    }
    lastHandledTickRef.current = tick;
    onConsume?.();
  }, [lastHandledTickRef, onConsume, tick]);
};
